import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import VisualPageBuilder from '@/components/VisualPageBuilder';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_ABOUT_HTML = `<div style="font-family: system-ui, -apple-system, sans-serif; color: white; padding: 2rem; background: #000;">
  <div style="text-align: center; margin-bottom: 3rem;">
    <h2 style="font-size: 3rem; font-weight: 300; letter-spacing: 0.15em; margin-bottom: 1rem; color: white;">Σχετικά με εμάς</h2>
    <p style="font-size: 1.2rem; color: #9ca3af; max-width: 700px; margin: 0 auto; font-weight: 300; line-height: 1.7;">
      Το DIMAKAS Modern Male Image είναι ένα σύγχρονο κομμωτήριο αφιερωμένο στην επαγγελματική περιποίηση ανδρών.
    </p>
  </div>
  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem; margin-bottom: 2rem;">
    <div style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 2rem;">
      <h3 style="font-size: 1.1rem; font-weight: 300; color: white; margin-bottom: 0.75rem; letter-spacing: 0.1em; text-transform: uppercase;">Διεύθυνση</h3>
      <p style="color: #9ca3af; font-weight: 300;">Κεντρική Αθήνα, Ελλάδα</p>
    </div>
    <div style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 2rem;">
      <h3 style="font-size: 1.1rem; font-weight: 300; color: white; margin-bottom: 0.75rem; letter-spacing: 0.1em; text-transform: uppercase;">Τηλέφωνο</h3>
      <p style="color: #9ca3af; font-weight: 300;">+30 210 XXX XXXX</p>
    </div>
    <div style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 2rem;">
      <h3 style="font-size: 1.1rem; font-weight: 300; color: white; margin-bottom: 0.75rem; letter-spacing: 0.1em; text-transform: uppercase;">Email</h3>
      <p style="color: #9ca3af; font-weight: 300;">dimakashair@gmail.com</p>
    </div>
    <div style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 2rem;">
      <h3 style="font-size: 1.1rem; font-weight: 300; color: white; margin-bottom: 0.75rem; letter-spacing: 0.1em; text-transform: uppercase;">Ώρες Λειτουργίας</h3>
      <p style="color: #9ca3af; font-weight: 300; line-height: 2;">
        Δευτέρα - Παρασκευή: 09:00 - 20:00<br/>
        Σάββατο: 09:00 - 18:00<br/>
        Κυριακή: Κλειστά
      </p>
    </div>
  </div>
  <div style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); padding: 2rem;">
    <h3 style="font-size: 1.5rem; font-weight: 300; color: white; margin-bottom: 1.5rem; letter-spacing: 0.1em;">Οι Υπηρεσίες μας</h3>
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;">
      <div>
        <h4 style="font-weight: 400; color: white; margin-bottom: 0.5rem;">Κούρεμα &amp; Styling</h4>
        <p style="color: #9ca3af; font-weight: 300;">Κλασικά και σύγχρονα κουρέματα προσαρμοσμένα στο στυλ σας</p>
      </div>
      <div>
        <h4 style="font-weight: 400; color: white; margin-bottom: 0.5rem;">Περιποίηση Γενιών</h4>
        <p style="color: #9ca3af; font-weight: 300;">Επαγγελματική περιποίηση και τρίμμισμα γενιών</p>
      </div>
      <div>
        <h4 style="font-weight: 400; color: white; margin-bottom: 0.5rem;">Προϊόντα Περιποίησης</h4>
        <p style="color: #9ca3af; font-weight: 300;">Προτείνουμε επιλεγμένα προϊόντα υψηλής ποιότητας</p>
      </div>
      <div>
        <h4 style="font-weight: 400; color: white; margin-bottom: 0.5rem;">Συμβουλές Styling</h4>
        <p style="color: #9ca3af; font-weight: 300;">Εξατομικευμένες συμβουλές για το κατάλληλο look</p>
      </div>
    </div>
  </div>
</div>`;

function AboutPage({ isAdmin }) {
  const [savedContent, setSavedContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/pages/about`);
      if (response.data.html) {
        setSavedContent(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch page content:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleBuilderSaved = () => {
    fetchContent();
  };

  if (loading) {
    return <div className="text-center text-gray-400 py-12">Φόρτωση...</div>;
  }

  // Scope GrapesJS CSS so it only applies inside our container
  const baseCss = savedContent?.css
    ? savedContent.css
        .replace(/\*\s*\{[^}]*\}/g, '')        // remove * { ... }
        .replace(/body\s*\{[^}]*\}/g, '')       // remove body { ... }
        .replace(/(^|})\s*#/g, '$1 .about-gjs-scope #')  // scope ID selectors only (not color values)
    : '';

  // Add responsive overrides: make all 2-col grids single-column on mobile
  const scopedCss = baseCss + `
    @media (max-width: 640px) {
      .about-gjs-scope,
      .about-gjs-scope * {
        grid-template-columns: 1fr !important;
        max-width: 100% !important;
        overflow-wrap: break-word !important;
        word-break: break-word !important;
      }
      .about-gjs-scope > div {
        padding: 1rem !important;
      }
      .about-gjs-scope h2 {
        font-size: 1.8rem !important;
        letter-spacing: 0.05em !important;
      }
      .about-gjs-scope h3 {
        font-size: 1rem !important;
      }
      .about-gjs-scope p {
        font-size: 0.9rem !important;
      }
    }
  `;

  const cleanHtml = savedContent?.html
    ? savedContent.html.replace(/<\/?body[^>]*>/gi, '')
    : '';

  return (
    <div data-testid="about-page">
      {savedContent?.html ? (
        <div className="about-gjs-scope w-full max-w-full overflow-hidden">
          {scopedCss && (
            <style dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(scopedCss) }} />
          )}
          <div
            className="w-full max-w-full"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cleanHtml) }}
          />
        </div>
      ) : (
        <div className="space-y-8">
          <div className="text-center space-y-4">
            <h2 className="text-5xl font-light tracking-wide">Σχετικά με εμάς</h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto font-light leading-relaxed">
              Το DIMAKAS Modern Male Image είναι ένα σύγχρονο κομμωτήριο αφιερωμένο στην επαγγελματική περιποίηση ανδρών.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white/5 border border-white/10 p-8">
              <h3 className="text-sm font-light text-white mb-3 tracking-widest uppercase">Διεύθυνση</h3>
              <p className="text-gray-400 font-light">Κεντρική Αθήνα, Ελλάδα</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-8">
              <h3 className="text-sm font-light text-white mb-3 tracking-widest uppercase">Τηλέφωνο</h3>
              <p className="text-gray-400 font-light">+30 210 XXX XXXX</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-8">
              <h3 className="text-sm font-light text-white mb-3 tracking-widest uppercase">Email</h3>
              <p className="text-gray-400 font-light">dimakashair@gmail.com</p>
            </div>
            <div className="bg-white/5 border border-white/10 p-8">
              <h3 className="text-sm font-light text-white mb-3 tracking-widest uppercase">Ώρες Λειτουργίας</h3>
              <p className="text-gray-400 font-light leading-loose">
                Δευτέρα – Παρασκευή: 09:00 – 20:00<br />
                Σάββατο: 09:00 – 18:00<br />
                Κυριακή: Κλειστά
              </p>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 p-8">
            <h3 className="text-2xl font-light text-white mb-6 tracking-wide">Οι Υπηρεσίες μας</h3>
            <div className="grid md:grid-cols-2 gap-6 text-gray-400 font-light">
              <div>
                <h4 className="font-normal text-white mb-2">Κούρεμα & Styling</h4>
                <p>Κλασικά και σύγχρονα κουρέματα προσαρμοσμένα στο στυλ σας</p>
              </div>
              <div>
                <h4 className="font-normal text-white mb-2">Περιποίηση Γενιών</h4>
                <p>Επαγγελματική περιποίηση και τρίμμισμα γενιών</p>
              </div>
              <div>
                <h4 className="font-normal text-white mb-2">Προϊόντα Περιποίησης</h4>
                <p>Προτείνουμε επιλεγμένα προϊόντα υψηλής ποιότητας</p>
              </div>
              <div>
                <h4 className="font-normal text-white mb-2">Συμβουλές Styling</h4>
                <p>Εξατομικευμένες συμβουλές για το κατάλληλο look</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Visual Builder — bottom, admin only */}
      <VisualPageBuilder pageId="about" isAdmin={isAdmin} onSaved={handleBuilderSaved} defaultContent={DEFAULT_ABOUT_HTML} />
    </div>
  );
}

export default AboutPage;
